'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _underscore = require('underscore');

var _underscore2 = _interopRequireDefault(_underscore);

var _auroraJavascriptUtils = require('@unitedtraders/aurora-javascript-utils');

var _cachedCollectionFactory = require('./cachedCollectionFactory');

var _utils = require('../utils');

var _hateoasModelFactory = require('../hateoasModelFactory');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var logger = _auroraJavascriptUtils.log.getLogger('cache');

/**
 * Read only entity cann't be fetched by id
 */
function isReadOnlyModel(hateoasType) {
    return hateoasType.startsWith(_hateoasModelFactory.SURROGATE_HATEOAS_TYPE_PREFIX);
}

function isValidaModelId(modelId) {
    if (_underscore2.default.isString(modelId)) {
        return true;
    }

    if (_underscore2.default.isNumber(modelId)) {
        return true;
    }

    return false;
}

function isModelFullFilled(rawModel) {
    var filteredLinks = (0, _utils.extractRelationsLinks)(rawModel._links || {});
    var notFetchedLinks = (0, _utils.extractNotFetchedLinks)(rawModel, filteredLinks);

    if (_underscore2.default.keys(notFetchedLinks).length !== 0) {
        return false;
    }

    return true;
}

/**
 * Store for fetched entities and collections.
 * For internal usage only!
 */

var Cache = function () {
    function Cache() {
        _classCallCheck(this, Cache);

        this._entityCache = {};
        this._collectionsCache = {};
    }

    _createClass(Cache, [{
        key: 'createCacheForModel',
        value: function createCacheForModel(Model) {
            var CachedCollectionConstructor = (0, _cachedCollectionFactory.createCachedCollectionConstructor)(Model);
            this._entityCache[Model.hateoasType] = new CachedCollectionConstructor([], { enableCreation: true });
        }
    }, {
        key: 'getEntity',
        value: function getEntity(hateoasType, modelId) {
            _auroraJavascriptUtils.assert.string(hateoasType);
            _auroraJavascriptUtils.assert.checkArgument(isValidaModelId(modelId), 'wrong model id \'' + modelId + '\'');

            var cachedCollection = this._getEntityCachedCollection(hateoasType);
            return cachedCollection.get(modelId); // cached collection always return model
        }
    }, {
        key: 'getEntityIfPresent',
        value: function getEntityIfPresent(hateoasType, modelId) {
            if (!modelId) {
                return null;
            }
            _auroraJavascriptUtils.assert.string(hateoasType);

            if (isReadOnlyModel(hateoasType)) {
                return null;
            }

            var cachedCollection = this._getEntityCachedCollection(hateoasType);
            return cachedCollection.get(modelId); // cached collection always return model
        }
    }, {
        key: 'addEntity',
        value: function addEntity(model) {
            if (isReadOnlyModel(model.hateoasType)) {
                return;
            }

            var cachedCollection = this._getEntityCachedCollection(model.hateoasType);
            cachedCollection.add(model);
        }

        /**
         * for internal usage only!
         */

    }, {
        key: 'getPagedCollection',
        value: function getPagedCollection(options) {
            var _this = this;

            var PagedCollectionConstructor = options.PagedCollectionConstructor,
                key = options.key,
                methodName = options.methodName,
                navigation = options.navigation,
                parameters = options.parameters,
                releaseCallback = options.releaseCallback,
                additionalInfo = options.additionalInfo;


            var cacheKey = PagedCollectionConstructor.hateoasModel.hateoasType + '#' + methodName + '#' + key;

            var collection = this._collectionsCache[cacheKey];
            if (!collection) {
                var internalReleaseCallback = function internalReleaseCallback() {
                    _this._releasePagedCollection(PagedCollectionConstructor.hateoasModel, methodName, key);
                    if (releaseCallback) {
                        releaseCallback();
                    }
                };

                var collectionOptions = _underscore2.default.extend({}, {
                    navigation: navigation,
                    parameters: parameters,
                    additionalInfo: additionalInfo
                }, {
                    releaseCallback: internalReleaseCallback
                });

                collection = new PagedCollectionConstructor([], collectionOptions);
                collection.fetch();
                this._collectionsCache[cacheKey] = collection;
            } else {
                logger.info('\'' + methodName + '\' with key ' + key + ' fetched from cache');
            }

            collection._refereceCounter.retain();
            return collection;
        }

        /**
         * for internal usage only!
         */

    }, {
        key: '_releasePagedCollection',
        value: function _releasePagedCollection(model, methodName, key) {
            var cacheKey = model.hateoasType + '#' + methodName + '#' + key;

            delete this._collectionsCache[cacheKey];
        }
    }, {
        key: 'getCacheStore',
        value: function getCacheStore() {
            var that = this;
            return {
                get: function get(name) {
                    return that._entityCache[name];
                }
            };
        }

        /**
         * if model has external reference - skip eager cache
         * For internal usage only.
         */

    }, {
        key: 'addRawModelIfPossible',
        value: function addRawModelIfPossible(rawModel) {
            if (!isModelFullFilled(rawModel)) {
                return;
            }

            var model = _underscore2.default.clone(rawModel);
            model.id = (0, _utils.extractIdFromHateoasModel)(rawModel);
            delete model._links;

            var hateoasType = (0, _utils.extractModelTypeFromHateoasModel)(rawModel);
            var cachedCollection = this._getEntityCachedCollection(hateoasType);
            cachedCollection.add(model);
        }
    }, {
        key: '_getEntityCachedCollection',
        value: function _getEntityCachedCollection(hateoasType) {
            _auroraJavascriptUtils.assert.string(hateoasType);

            return _auroraJavascriptUtils.assert.object(this._entityCache[hateoasType]);
        }

        /**
         * @param hateoasType - type of collections, which we need to invalidate after changes
         * @deprecated
         */

    }, {
        key: 'invalidateCollections',
        value: function invalidateCollections(hateoasType) {
            var _this2 = this;

            _auroraJavascriptUtils.assert.string(hateoasType);

            return _underscore2.default.keys(this._collectionsCache).filter(function (cacheKey) {
                return cacheKey.startsWith(hateoasType);
            }).map(function (cacheKey) {
                return _this2._collectionsCache[cacheKey];
            }).forEach(function (collection) {
                return collection.reload();
            });
        }

        /**
         * @param model {function}
         */

    }, {
        key: 'invalidateModelCollections',
        value: function invalidateModelCollections(model) {
            var _this3 = this;

            _auroraJavascriptUtils.assert.func(model);
            var hateoasType = _auroraJavascriptUtils.assert.string(model.hateoasType);

            return _underscore2.default.keys(this._collectionsCache).filter(function (cacheKey) {
                return cacheKey.startsWith(hateoasType);
            }).map(function (cacheKey) {
                return _this3._collectionsCache[cacheKey];
            }).forEach(function (collection) {
                return collection.reload();
            });
        }
    }, {
        key: 'invalidateEntities',
        value: function invalidateEntities(model) {
            var _this4 = this;

            _auroraJavascriptUtils.assert.func(model);
            var hateoasType = _auroraJavascriptUtils.assert.string(model.hateoasType);

            var reloadEntities = function reloadEntities(entities) {
                return entities.forEach(function (entity) {
                    if (entity.id && entity.id !== -1) {
                        entity.fetch();
                    }
                });
            };

            return _underscore2.default.keys(this._entityCache).filter(function (cacheKey) {
                return cacheKey.startsWith(hateoasType);
            }).map(function (cacheKey) {
                return _this4._entityCache[cacheKey];
            }).forEach(reloadEntities);
        }
    }, {
        key: 'invalidate',
        value: function invalidate(model) {
            this.invalidateModelCollections(model);
            this.invalidateEntities(model);
        }
    }]);

    return Cache;
}();

exports.default = Cache;


//////////////////
// WEBPACK FOOTER
// ./~/@unitedtraders/nested-hateoas/dist/cache/Cache.js
// module id = 1411
// module chunks = 118